"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    align: 'center',
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map